// src/services/memberDisplayService.js
// Resolves other people's display names without reading user_profiles.
// Members can only read their own profile row (RLS); the SECURITY DEFINER
// function get_member_display_names returns just id + display name for people
// in the caller's own HOA (max 200 ids per call).

import { supabase } from '../lib/supabase';

const MAX_IDS_PER_CALL = 200;

/**
 * @param {Array<string|null|undefined>} ids
 * @returns {Promise<Map<string, {full_name: string}>>} id -> { full_name }.
 *   Ids without a resolvable name are omitted. Never throws.
 */
export const getDisplayNames = async (ids) => {
  const names = new Map();
  const uniqueIds = [...new Set((ids || []).filter(Boolean))];
  if (!uniqueIds.length) return names;

  for (let i = 0; i < uniqueIds.length; i += MAX_IDS_PER_CALL) {
    const chunk = uniqueIds.slice(i, i + MAX_IDS_PER_CALL);
    try {
      const { data, error } = await supabase.rpc('get_member_display_names', { p_ids: chunk });
      if (error) {
        console.warn('get_member_display_names failed:', error.message);
        continue;
      }
      (data || []).forEach((row) => {
        if (row?.id && row.display_name) names.set(row.id, { full_name: row.display_name });
      });
    } catch (e) {
      console.warn('get_member_display_names failed:', e?.message || e);
    }
  }

  return names;
};
